import { Box } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/en-gb';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../api/api';
import { useEffect, useState } from 'react';

const WorkTimeReportDateRange = ({ startDate, endDate, onChange }) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [format, setFormat] = useState('YYYY-MM-DD');

  useEffect(() => {
    if (config?.general?.dateOutputFormat) {
      setFormat(config.general.dateOutputFormat);
    }
  }, [config]);

  useEffect(() => {
    moment.locale('en-gb');
  }, []);

  const handleStartChange = (newDate) => {
    if (!newDate || !newDate.isValid()) return;
    const formatted = newDate.format('YYYY-MM-DD');
    const endMoment = moment(endDate);
    if (endMoment.isValid() && newDate.isAfter(endMoment)) {
      onChange({ startDate: formatted, endDate: formatted });
    } else {
      onChange({ startDate: formatted, endDate });
    }
  };

  const handleEndChange = (newDate) => {
    if (!newDate || !newDate.isValid()) return;
    const formatted = newDate.format('YYYY-MM-DD');
    const startMoment = moment(startDate);
    if (startMoment.isValid() && newDate.isBefore(startMoment)) {
      onChange({ startDate: formatted, endDate: formatted });
    } else {
      onChange({ startDate, endDate: formatted });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box className="flex items-center gap-2">
        <DatePicker
          views={['day']}
          label={t('Start date')}
          format={format}
          value={startDate ? moment(startDate) : null}
          onChange={handleStartChange}
          disableFuture
          slotProps={{ textField: { size: 'small', sx: { width: 150 } } }}
        />
        <DatePicker
          views={['day']}
          label={t('End date')}
          format={format}
          value={endDate ? moment(endDate) : null}
          onChange={handleEndChange}
          disableFuture
          slotProps={{ textField: { size: 'small', sx: { width: 150 } } }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default WorkTimeReportDateRange;
